module.exports = __webpack_public_path__ + "static/media/wirebasket4point.7f5da581.png";